<template>
  <div>
    <van-popup
      v-model="isShowPopup"
      position="bottom"
      :style="{ height: '100%' }"
    >
      <div
        class="lm-container"
      >
        <div
          class="lm-starlight"
        ></div>
        <div
          v-if="showFirework"
          class="lm-firework-small"
        ></div>
        <div
          v-if="showFirework"
          class="lm-firework-middle"
        ></div>
        <div
          v-if="showFirework"
          class="lm-firework-big"
        ></div>
        <div
          v-if="lotteryBank.bankIcon"
          class="lm-bank"
        >
          <div
            class="lm-bank-logo"
            :style="{ backgroundImage: 'url(' + lotteryBank.bankIcon + ')' }"
          ></div>
          <div class="lm-bank-name">
            {{ lotteryBank.bankName }}
          </div>
          <div class="lm-bank-tip">
            祝你
          </div>
        </div>
        <div
          class="lm-title"
        >
          {{ accessoryInfo.greetings }}
        </div>
        <div
          class="lm-content"
        >
          <div
            class="lm-content-award"
          >
            <div
              class="lm-content-award-info"
            >
              <div
                class="lm-content-award-info-title"
              >头像挂件</div>
              <div
                class="lm-content-award-info-detail"
              >
                <span>数字人民币头像是官方发行的唯一头像，可在<span>最新版本数字人民币App</span>为头像佩戴挂件～</span>
              </div>
            </div>
            <div
              class="lm-content-award-show"
            >
              <div
                v-if="portrait"
                class="lm-content-award-show-pic-portrait"
                :style="{ backgroundImage: 'url(' + portrait + ')' }"
              >
                <div
                  v-if="accessoryInfo.rewardPicture.dynamic"
                  ref="accessoryEle"
                  class="lm-content-award-show-pic-portrait-accessory"
                ></div>
              </div>
              <div
                class="lm-content-award-show-guide portrait-guide"
                @click="goSetAvatarGuide"
              >查看头像攻略</div>
            </div>
          </div>
          <div
            class="lm-content-award"
          >
            <div
              class="lm-content-award-info"
            >
              <div
                class="lm-content-award-info-title"
              >{{ awardInfo.rewardName }}</div>
              <div
                class="lm-content-award-info-detail"
              >
                <span>{{ awardInfo.rewardDesc }}</span>
              </div>
            </div>
            <div
              class="lm-content-award-show"
            >
              <div
                v-if="awardInfo.rewardPicture"
                class="lm-content-award-show-pic"
                :style="{ backgroundImage: 'url(' + awardInfo.rewardPicture.static + ')' }"
              >
              </div>
              <div
                class="lm-content-award-show-guide"
                @click="goAwardGuide"
              >{{ awardGuideText }}</div>
            </div>
          </div>
          <div
            class="lm-content-share-btn"
            @click="onHanleShare"
          >
            {{ shareBtnText }}
          </div>
          <div
            class="lm-content-close-btn"
            @click="onHandleReceiveAward"
          >
          </div>
        </div>
        <div
          class="lm-bottom-bg"
        ></div>
        <div class="lm-circular-container">
          <circular></circular>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import { Popup } from 'vant';
import lottie from 'lottie-web';
import { lx } from '@/analytic/index';
import { lxConfig } from '@/analytic/profilePhoto';
import { lotteryActivityId } from '@/common/config';
import { env } from '@/common/env';
import Circular from './Circular.vue';
import { bankInfo } from '../../config/bankInfo';
import { guideLink } from '../../config/guideLink';

Vue.use(Popup);

export default {
  components: {
    Circular
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    hctUserRewardInfoBOS: {
      type: Array,
      default: () => []
    },
    portraitStatus: {
      type: Boolean,
      default: false
    },
    appPortrait: {
      type: String,
      default: ''
    },
    lotteryCount: {
      type: String,
      default: ''
    },
    cityId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isShowPopup: this.visible,
      accessoryLottie: null,
      showFirework: false
    };
  },
  computed: {
    lotteryBank() {
      const lottery = (this.hctUserRewardInfoBOS && this.hctUserRewardInfoBOS[this.hctUserRewardInfoBOS.length - 1]) || {};
      if (!lottery.bankTypeId) {
        return {};
      }
      const bank = bankInfo[lottery.bankTypeId];
      return bank;
    },
    accessoryInfo() {
      const accessory = this.parseAccessory(true);
      const pictureJson = (accessory && accessory.rewardPicture) || '';
      const pictureObj = this.parsePictureJson(pictureJson);
      accessory.rewardPicture = pictureObj;
      return accessory;
    },
    awardInfo() {
      const award = this.parseAccessory(false);
      const pictureJson = (award && award.rewardPicture) || '';
      const pictureObj = this.parsePictureJson(pictureJson);
      award.rewardPicture = pictureObj;
      return award;
    },
    shareBtnText() {
      if (Number(this.lotteryCount) === 2) {
        return '分享彩头';
      }
      return '分享彩头 再抽一次';
    },
    portrait() {
      if (this.portraitStatus) {
        return this.appPortrait;
      }
      return 'https://p0.meituan.net/wxapp/c6a436105a62d7a8029cbd46609f13c44783.png';
    },
    awardGuideText() {
      let text = '';
      const type = (this.awardInfo && this.awardInfo.rewardType) || '';
      if (type === 'REDPCT') {
        text = '查看使用攻略';
      } else if (type === 'HD_WALLET') {
        text = '查看兔卡攻略';
      } else if (type === 'ONE_YUAN_PURCHASE') {
        text = '查看使用攻略';
      } else if (type === 'COUPON') {
        text = '查看使用攻略';
      }
      return text;
    }
  },
  watch: {
    visible(newValue, oldValue) {
      this.isShowPopup = newValue;
      if (newValue) {
        lx.mv(lxConfig.lottery_modal_mv, {
          activity_id: env.actGroupName || lotteryActivityId,
          bank_id: this.lotteryBank.bankId,
          status: this.lotteryCount,
          city_id: this.cityId
        }, {
          cid: lxConfig.index_pv
        });
        if (!this.accessoryLottie) {
          this.initAccessoryLottie();
        }
        this.fireworkOnce();
      } else {
        if (this.accessoryLottie) {
          this.accessoryLottie.destroy('accessoryLottie');
          this.accessoryLottie = null;
        }
      }
    },
    isShowPopup(newValue, oldValue) {
      if (!newValue) {
        this.$emit('update:visible', false);
        this.$emit('onClose');
      }
    }
  },
  methods: {
    fireworkOnce() {
      setTimeout(() => {
        this.showFirework = true;
      }, 1000);
      setTimeout(() => {
        this.showFirework = false;
      }, 1800);
    },
    closeModal() {
      this.isShowPopup = false;
    },
    initAccessoryLottie() {
      setTimeout(() => {
        this.accessoryLottie = lottie.loadAnimation({
          container: this.$refs.accessoryEle,
          renderer: 'svg',
          name: 'accessoryLottie',
          loop: true,
          autoplay: false,
          path: this.accessoryInfo.rewardPicture.dynamic
        });
        this.accessoryLottie.addEventListener('loaded_images', () => {
          this.$nextTick(() => {
            this.accessoryLottie.play();
          });
        });
      }, 0);
    },
    onHandleReceiveAward() {
      this.lxMc(lxConfig.lottery_modal_receive_btn_mc);
      this.closeModal();
    },
    onHanleShare() {
      this.lxMc(lxConfig.lottery_modal_share_btn_mc);
      this.$emit('onShareLottery');
      this.closeModal();
    },
    goSetAvatarGuide() {
      lx.addTag({
        c_fsp_dcep_j4pmca31: {
          bid: lxConfig.lottery_modal_accessory_guide_btn_mc
        }
      });
      this.lxMc(lxConfig.lottery_modal_accessory_guide_btn_mc);
      this.$bridge.openPage(guideLink.avatar);
    },
    goAwardGuide() {
      let url = '';
      const type = (this.awardInfo && this.awardInfo.rewardType) || '';
      console.log('type', type);
      if (type === 'REDPCT') {
        url = this.lotteryBank.redpctGuide;
      } else if (type === 'HD_WALLET') {
        url = guideLink.hardWallet;
      } else if (type === 'ONE_YUAN_PURCHASE') {
        url = guideLink.oneBuy;
      } else if (type === 'COUPON') {
        url = this.lotteryBank.couponGuide;
      }
      lx.addTag({
        c_fsp_dcep_j4pmca31: {
          bid: lxConfig.lottery_modal_award_guide_btn_mc
        }
      });
      this.lxMc(lxConfig.lottery_modal_award_guide_btn_mc);
      console.log('url', url);
      this.$bridge.openPage(url);
    },
    parseAccessory(isAccessory) {
      const lottery = (this.hctUserRewardInfoBOS && this.hctUserRewardInfoBOS[this.hctUserRewardInfoBOS.length - 1]) || {};
      if (!lottery.singleRewardInfos) {
        return {};
      }
      const singleRewardInfos = lottery.singleRewardInfos || [];
      let item = null;
      if (isAccessory) {
        item = singleRewardInfos.find((s) => s.rewardType === 'ACCESSORY');
      } else {
        item = singleRewardInfos.find((s) => {
          if (singleRewardInfos.length > 2) {
            // 返回三个权益时，不展示红包(邮储会有红包+券包+挂件的场景)
            return (s.rewardType !== 'ACCESSORY') && (s.rewardType !== 'REDPCT');
          } else {
            return s.rewardType !== 'ACCESSORY';
          }
        });
      }
      if (!item) {
        return {};
      }
      return item;
    },
    parsePictureJson(jsonStr) {
      if (!jsonStr) {
        return {
          static: '',
          dynamic: ''
        };
      }
      if (typeof (jsonStr) === 'string') {
        const json = JSON.parse(jsonStr);
        return json;
      }
      return jsonStr;
    },
    lxMc(bid) {
      lx.mc(bid, {
        activity_id: env.actGroupName || lotteryActivityId,
        bank_id: this.lotteryBank.bankId,
        status: this.lotteryCount,
        city_id: this.cityId
      }, {
        cid: lxConfig.index_pv
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import '../../../../styles/base.less';
@import '../../../../styles/fn.less';
.lm-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-x: hidden;
}
.lm-starlight {
  position: absolute;
  left: 0;
  top: 2.8rem;
  .block-image(100vw, 79vw, 'https://p0.meituan.net/wxapp/ee54e612b295ef3913dd6d9a187d83053009.png');
}
.lm-firework-small {
    position: absolute;
    left: 2rem;
    top: 2.5rem;
    .block-image(.5rem, .5rem, 'https://p1.meituan.net/wxapp/dda2428ee48978fcf94863516a40766f438.png');
    .firework(1s);
  }
.lm-firework-middle {
  position: absolute;
  right: 1.1rem;
  top: 2.6rem;
  .block-image(.8rem, .8rem, 'https://p0.meituan.net/wxapp/748330c6f7015357002f8e5ff22be495853.png');
  .firework(1s);
}
.lm-firework-big {
  position: absolute;
  left: 0.6rem;
  top: 3.6rem;
  .block-image(1rem, 1rem, 'https://p1.meituan.net/wxapp/2876ff4ad4e9714aeb274a534492d6f01071.png');
  .firework(1s);
}
.lm-bank {
  display: flex;
  margin-top: 2.31rem;
  height: .3rem;
  justify-content: center;
  &-logo {
    .size(.25rem, .25rem);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin: .025rem .06rem 0 0;
  }
  &-name {
    font-family: PingFangSC-Medium;
    font-size: .22rem;
    color: #FFF;
    font-weight: 500;
    height: .3rem;
    line-height: .3rem;
    margin-right: .06rem;
  }
  &-tip {
    font-family: PingFangSC-Regular;
    font-size: .2rem;
    color: #FFF;
    font-weight: 400;
    height: .3rem;
    line-height: .3rem;
  }
}
.lm-title {
  font-family: 'MF-YuanHeiNoncommercial-Regular';
  font-size: .58rem;
  height: .58rem;
  line-height: .58rem;
  margin: .22rem auto .34rem auto;
  text-align: center;
  background: linear-gradient(#FFFFFF, #FFE4B7);
  -webkit-background-clip: text;
  color: transparent;
  position: relative;
}
.lm-content {
  .block-image(6.03rem, 8.59rem, 'https://p0.meituan.net/wxapp/97f96fc99c2e203d01ae129e6d57d11c29542.png');
  margin: 0 auto;
  position: relative;
  z-index: 1;
  padding-top: .87rem;
  &-award {
    .block-image(5rem, 2.34rem, 'https://p1.meituan.net/wxapp/02b3f0b7e36794bab60b481ed202223a5577.png');
    margin: 0 auto .2rem auto;
    display: flex;
    justify-content: space-between;
    padding: 0 .45rem 0 .35rem;
    position: relative;
    &-info {
      margin: .66rem 0 0 0;
      &-title {
        font-family: PingFangSC-Medium;
        font-size: .26rem;
        color: #811500;
        font-weight: 500;
        height: .26rem;
        line-height: .26rem;
        margin-bottom: .1rem;
      }
      &-detail {
        opacity: 0.64;
        font-family: PingFangSC-Regular;
        font-size: .36rem;
        color: #811500;
        font-weight: 400;
        width: 2.45rem;
        & > span {
          transform: scale(0.5);
          transform-origin: top left;
          display: inline-block;
          width: 5.2rem;
          & > span {
            color: #ED0000;
            font-weight: 600;
          }
        }
      }
    }
    &-show {
      width: 1.5rem;
      margin: .46rem 0 0 0;
      &-pic {
        .size(1.2rem, 1.2rem);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        margin: 0 auto;
        position: relative;
      }
      &-pic-portrait {
        .size(1.05rem, 1.05rem);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        margin: 0 auto;
        position: relative;
        &-accessory {
          position: absolute;
          top: -0.175rem;
          left: -0.175rem;
          width: 1.4rem;
          height: 1.4rem;
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
      }
      &-guide {
        font-family: PingFangSC-Regular;
        font-size: .2rem;
        color: #3C72FA;
        text-align: center;
        font-weight: 400;
        margin-top: .05rem;
        position: absolute;
        z-index: 9999;
        bottom: 30px;
        width: 1.5rem;
      }
      .portrait-guide {
        margin-top: .1rem;
      }
    }
  }
  &-share-btn {
    .block-image(3.83rem, 0.87rem, 'https://p0.meituan.net/wxapp/dadecf78b1649fe3e63085bb75f2b2ad10656.png');
    margin: 0 auto;
    text-align: center;
    line-height: 0.89rem;
    font-family: PingFangSC-Medium;
    font-size: .3rem;
    color: #811500;
    font-weight: 600;
  }
  &-close-btn {
    .block-image(3.83rem, 0.87rem, 'https://p0.meituan.net/wxapp/3022cdfbadb5b2a4b60963847b31a7732662.png');
    margin: 0.2rem auto;
  }
}
.lm-bottom-bg {
  position: absolute;
  bottom: 0;
  .block-image(100vw, 48vw, 'https://p0.meituan.net/wxapp/756174624826e34b824116d12b278175250846.png');
}
.lm-circular-container {
  position: absolute;
  left: 50%;
  top: 45%;
  width: 100vw;
  height: 90vh;
  overflow: hidden;
  transform: translate(-50%, -50%);
}
.van-popup {
  background-color: transparent;
}
/deep/ .van-overlay {
  background-color: rgba(0,0,0,.85) !important;
}
</style>
